<template>
	<span> {{time}} МСК</span>
</template>


<script>
import moment from 'moment-timezone';

export default {
	name: "CurrentTime",
	data() {
		return {
			moment: moment,
			time: moment().locale('ru').tz("Europe/Moscow").format('ddd, D  MMMM[,]  LT')
		}
	},
	mounted() {
		window.setInterval(() => {
			this.time = moment().locale('ru').tz("Europe/Moscow").format('ddd, D  MMMM[,]  LT')
		},5000)
	}
}
</script>
